import styled from 'styled-components';
import { CustomThemeToken } from '@/theme/theme.utils';

export const AdditionalInformationModalContainer = styled.div<{ theme: { token: CustomThemeToken } }>`
  .modal-header {
    .modal-title {
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    }
  }

  .modal-content {
    padding: ${({ theme: { token } }) => token.margin}px 0;
    border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};

    .form-section {
      display: flex;
      flex-direction: column;
      margin-bottom: ${({ theme: { token } }) => token.marginXL}px;

      .platform-pressure-row {
        display: flex;
        gap: ${({ theme: { token } }) => token.margin}px;
        align-items: stretch;

        .platform-field,
        .pressure-field {
          flex: 1;
        }
      }

      .top-row {
        display: flex;
        flex-direction: column;
        gap: ${({ theme: { token } }) => token.margin}px;
        margin-bottom: ${({ theme: { token } }) => token.margin}px;
        padding-bottom: ${({ theme: { token } }) => token.margin}px;
        border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};

        .field-wrapper {
          flex: 1;
        }
      }

      .bottom-row {
        display: flex;
        gap: ${({ theme: { token } }) => token.margin}px;
        align-items: stretch;

        .field-wrapper {
          flex: 1;
        }
      }
    }

    .divider-section {
      display: flex;
      align-items: center;
      margin-bottom: ${({ theme: { token } }) => token.margin}px;
      gap: ${({ theme: { token } }) => token.margin}px;

      .divider-line {
        flex: 1;
        height: 1px;
        background-color: ${({ theme: { token } }) => token.colorBorder};
      }
    }

    .manual-entry-section {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;
